import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 overflow-x-auto"
}
const _hoisted_2 = { class: "text-3xl font-medium" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "text-4xl font-medium capitalize" }
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { class: "text-4xl font-medium capitalize" }

import { ref } from "vue";
import { storeToRefs } from "pinia";

import TitleHeader from "../TitleHeader.vue";
import RouterButton from "../RouterButton.vue";
import UsersTable from "../tables/UsersTable.vue";
import EventsTable from "../tables/EventsTable.vue";
import ResourceCards from "../resources/ResourceCards.vue";
import ExternalLink from "../ExternalLink.vue";

import { useUserStore } from "@/store";
import api from "@/api/api";
import { Event, PaginationMeta, Resource, User } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrainerOrganisationDashboard',
  async setup(__props) {

let __temp: any, __restore: any

const { user } = storeToRefs(useUserStore());

const users = ref([] as User[]);
const meta = ref({} as PaginationMeta);
const resources = ref([] as Resource[]);
const satisfaction = ref(0);

const url = `${process.env.VUE_APP_WEBSITE_URL}/howto`;

async function listUsers() {
  const response = await api.users.listUsers({
    page: 1,
    role: "l4a-trainer",
  });

  users.value = response.data.users;
  meta.value = response.meta;
}

async function listResources() {
  resources.value = (
    await api.resources.listResources({
      role: "trainer-organisation",
      page: 1,
    })
  ).data.resources;
}

const events = ref([] as Event[]);
events.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.events.listEvents({
  page: 1,
  status: "published",
  added_by_user: true
}))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.events;

async function getSatisfaction() {
  const res = await api.surveys.getSurveySatifaction();
  satisfaction.value = res?.data?.overallScore;
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listUsers())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => listResources())),
  await __temp,
  __restore()
);

if (user.value.has_smartsurvey_access) {
  (
  ([__temp,__restore] = _withAsyncContext(() => getSatisfaction())),
  await __temp,
  __restore()
);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('welcome-back'),
      class: "mt-6"
    }, null, 8, ["title"]),
    (_unref(user).has_smartsurvey_access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("average-course-satisfaction")) + ": " + _toDisplayString(satisfaction.value), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ExternalLink, {
              type: "text",
              label: _ctx.$t('what-does-this-mean'),
              href: url,
              capitalize: false
            }, null, 8, ["label"])
          ]),
          _createVNode(RouterButton, {
            to: { name: 'Satisfaction_Survey' },
            type: "primary",
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("view-satisfaction-breakdown")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("your-trainers")), 1),
        (users.value.length > 4)
          ? (_openBlock(), _createBlock(RouterButton, {
              key: 0,
              to: { name: 'Users' },
              type: "primary",
              class: "mt-5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("view-all-trainers")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(UsersTable, {
        users: users.value.slice(0, 4),
        meta: meta.value,
        hide_pagination: true
      }, null, 8, ["users", "meta"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("training-events")), 1),
        _createVNode(RouterButton, {
          to: { name: 'Training_Events' },
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("see-all-training-events")), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(EventsTable, {
        events: events.value.slice(0, 5)
      }, null, 8, ["events"])
    ]),
    _createVNode(ResourceCards, {
      role: "trainer-organisation",
      resources: resources.value.splice(0, 3)
    }, null, 8, ["resources"])
  ], 64))
}
}

})